import { customActionApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const RULE_ACTIONS_ACTION_TYPE = createNamedActions('ruleActions', {
  GET_RULE_ACTIONS: 'GET_RULE_ACTIONS',
});

const actions = new schema.Entity('actions', {}, { idAttribute: 'name' });

export const getRuleActionsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await customActionApi.getCustomAction();

  return dispatch({
    type: RULE_ACTIONS_ACTION_TYPE.GET_RULE_ACTIONS,
    payload: normalize(data, [actions]).entities.actions,
  });
});
